import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="border-t border-electric/10 bg-navy py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-70" data-mp="9ttjujy9kf2v">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-71" data-mp="etpmofv860gu">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-electric bg-panel p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-72" data-mp="er36xsy6kenj">
          <span className="inline-flex rounded-full border border-electric bg-navy p-4 text-gold" data-id="element-73" data-mp="xivzjm9c7xuq">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-74" data-mp="12k35rgvu0oza" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-4xl font-bold tracking-tight text-white" data-id="element-75" data-mp="17hbslurxdh6v">
            7-Day Guarantee
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink" data-id="element-76" data-mp="25t8eerite9s7">
            Use all {totalVolumes} volumes and {totalBonuses} bonuses in your most challenging class this week. If your
            students don't respond better or materials don't save you hours,{' '}
            <span className="font-extrabold text-gold" data-id="element-77" data-mp="1rt7bl6izosa3">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}